export enum ediOrderTypes {
   EDI_DATA = 'EDI_DATA',
    EDI_SAVE = 'EDI_SAVE',

}